var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":2}},[_c('Steps',{attrs:{"stepIndex":_vm.index}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }